import Registry, { config, pushElement } from './appearRegistry';
import createIntersectionObserver, {
  observerElement,
  isExistIntersection,
} from './intersectionObserver';

let instance = null;
const existIntersection = isExistIntersection();

const appear = () => {
  if (existIntersection) {
    createIntersectionObserver();
    injectEventListenerHook();
  } else {
    const instances = [];

    Registry.createEvent();
    injectEventListenerHook(instances);

    instance = new Registry({
      container: window,
    });
    instances.push(instance);

    const control = {
      config,
    };

    return control;
  }
};

// hijack addEventListener、removeEventListener
const injectEventListenerHook = (instances = []) => {
  const nativeAddEventListener = Node.prototype.addEventListener;
  const nativeRemoveEventListener = Node.prototype.removeEventListener;
  let flag = false;

  Node.prototype.addEventListener = function (eventName, eventHandler, useCapture, isNotWatch) {
    const lowerCaseEventName = eventName.toLowerCase();
    if (lowerCaseEventName === 'appear' || lowerCaseEventName === 'disappear') {
      if (existIntersection) {
        observerElement(this);
      } else {
        pushElement(this);
      }
    }
    if (!existIntersection) {
      if (instance && !flag) {
        instance.check();
        flag = true;
      }

      if (lowerCaseEventName === 'scroll' && !isNotWatch) {
        instance = new Registry({
          container: this,
        });
        instances.push(instance);
      }
    }
    nativeAddEventListener.call(this, eventName, eventHandler, useCapture);
  };

  Node.prototype.removeEventListener = function (eventName, eventHandler, useCapture, isNotWatch) {
    const lowerCaseEventName = eventName.toLowerCase();

    // destroy scroller
    if (!existIntersection && lowerCaseEventName === 'scroll' && !isNotWatch) {
      instances.forEach((instance, index) => {
        if (instance.__handle && instance.container === this) {
          this.removeEventListener('scroll', instance.__handle, false, true);
          instance.__handle = null;
          instance.appearWatchElements = [];
          instance.container = null;
          instances.splice(index, 1);
        }
      });
    }
    nativeRemoveEventListener.call(this, eventName, eventHandler, useCapture);
  };
};

export default appear();
